export const SYMBOL = 'symbol';
export const SYMBOL_NARROW = 'symbol-narrow';
export const ONE_MIN_TWO_DECIMALS = '1.2-2';
export const ONE_MIN_ZERO_DECIMALS = '1.0-0';
